import React, { useMemo, useEffect, useState } from 'react';
import './dashboard.css';
import GroupsIcon from '@mui/icons-material/Groups';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { Typography, Grid, Box, Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useCommonInits } from 'hooks/useCommonInits';
import { ROUTE_PATHS } from 'app/utils/route';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import {
    getCounts,
    getGroups,
    getExecutersRequest,
    getlatestExecDataByID,
    getPanelValue,
    getAssets,
    getGroupsInfo,
    clearDataSource,
} from 'redux/datasource/dataSourceSlice';
import { useSelector } from 'react-redux';
import {
    getAssetsCount,
    getGroupsCount,
    getPricesCount,
    getUsersCount,
    getExecutedCountsByID,
    getExecutedCounts,
    getAllGroups,
    getPriceCountsByID,
    getExecutersData,
    getExecutedDatasByID,
    getAllPriceRequests,
    getPriceReqRaisedDataByID,
    getAssetsLiveData,
    getApcmGroup,
    getAllAssets,
    getGroupInfo,
    getNoConfirmedData,
    getNoExecutedData,
    getNoConfirmedCount,
    getNoExecutedCount,
    getUsersUnitCount,
} from 'redux/datasource/dataSourceActions';
import { getUser, getUnitIds } from 'redux/auth/authSlice';

const ApcmDashboard = panel => {
    const { dispatch, navigate, select } = useCommonInits();
    const user = select(getUser);
    const [pageSize, setPageSize] = useState(7);
    const [pages, setPages] = useState(7);
    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };
    const latestExecData = useSelector(getlatestExecDataByID);
    const getGroup = useSelector(getGroups);
    const executersData = useSelector(getExecutersRequest);
    const groupInfo = useSelector(getGroupsInfo);
    const Assets = select(getAssets);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const filteredGroups = getGroup?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });
    const panelData = useSelector(state =>
        getPanelValue(state, panel?.panelId),
    );

    const {
        asset: assetCounts,
        groups: groupCount,
        users: userCount,
        raisedRequest: reqCount,
        reqExecuted: execCount,
        raisedRequestID: reqCoundID,
        reqExecutedID: execCountID,
        noConfirmed: noConfirmed,
        noExecuted: noExecuted,
        unitsCount: unitCount,
    } = useSelector(getCounts);
    
    useEffect(() => {
        if (getGroup) {
            const params = {
                group_id: filteredGroups.map(group => group._id),
            };
            dispatch(getPriceCountsByID(params));
            dispatch(getExecutedCountsByID(params));
            dispatch(getExecutedDatasByID(params));
            dispatch(getPriceReqRaisedDataByID(params));
            // dispatch(getNoConfirmedData(params));
            dispatch(getNoExecutedData(params));
            dispatch(getNoConfirmedCount(params));
            dispatch(getNoExecutedCount(params));
        }
    }, [getGroup]);

    useEffect(() => {
        const params = { email: user.email };
        dispatch(getUsersUnitCount(params));
    }, []);

    useEffect(() => {
        dispatch(getAllGroups());
        dispatch(getAssetsCount());
        dispatch(getGroupsCount());
        dispatch(getUsersCount());
        dispatch(getPricesCount());
        dispatch(getExecutedCounts());
        dispatch(getExecutersData());
        dispatch(getAllPriceRequests());
        dispatch(getGroupInfo());
    }, []);

    useEffect(() => {
        const params = {
            filter: { EQUIP_TYPE: ['APCM'] },
            unit_id: units,
        };
        dispatch(getAllAssets(params));
    }, []);

    useEffect(() => {
        if (Assets) {
            dispatch(
                getAssetsLiveData({
                    params: { asset_list: Assets.map(i => i.asset_id) },
                    panelId: panel.panelId,
                }),
            );
        }
    }, [Assets]);

    const renderGroupId = id => {
        navigateTo(`/${ROUTE_PATHS.groupId}/${id}`);
        dispatch(getApcmGroup({ id }));
    };

    const renderTableData = id => {
        navigateTo(`/${ROUTE_PATHS.tableData}/${id}`);
        dispatch(getApcmGroup({ id }));
    };

    const renderExecuterId = id => {
        navigateTo(`/${ROUTE_PATHS.executor}/${id}`);
        dispatch(getApcmGroup({ id }));
    };
    const handleLiveAssets = () => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}`); //assets live data by id
    };
    const handleRowClick = _id => {
        if (user.app_type.includes('APCM_Executor')) {
            navigateTo(
                `/${ROUTE_PATHS.executorLogsByID}/${_id}`, //executed logs by id
            );
        }
    };

    const columns1 = useMemo(
        () => [
            {
                field: 'no',
                headerName: 'Sr.No.',
                width: 70,
                sortable: false,
                filterable: false,
                textAlign: 'center',
                renderCell: params =>
                    params.api.getRowIndex(params.row._id) + 1,
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'center',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.group_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price_request_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'price',
                headerName: 'Current Price',
                width: 110,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price}
                        </Typography>
                    );
                },
            },
        ],
        [],
    );

    const columns = useMemo(
        () => [
            {
                field: 'no',
                headerName: 'Sr.No.',
                width: 110,
                sortable: false,
                filterable: false,
                textAlign: 'center',
                renderCell: params =>
                    params.api.getRowIndex(params.row._id) + 1,
            },
            {
                field: 'name',
                headerName: 'Group Name',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (user.app_type.includes('APCM')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderTableData(params.row._id)}
                            >
                                {params.row.name}
                            </Typography>
                        );
                    } else if (user.app_type.includes('APCM_Authorizer')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderGroupId(params.row._id)}
                            >
                                {params.row.name}
                            </Typography>
                        );
                    } else if (user.app_type.includes('APCM_Executor')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderExecuterId(params.row._id)}
                            >
                                {params.row.name}
                            </Typography>
                        );
                    }
                },
            },

            {
                field: 'current_price',
                headerName: 'Current Price',
                width: 170,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (user.app_type.includes('APCM')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderTableData(params.row._id)}
                            >
                                {params.row.current_price}
                            </Typography>
                        );
                    } else if (user.app_type.includes('APCM_Authorizer')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderGroupId(params.row._id)}
                            >
                                {params.row.current_price}
                            </Typography>
                        );
                    } else if (user.app_type.includes('APCM_Executor')) {
                        return (
                            <Typography
                                style={{
                                    width: '300px',
                                    height: '50px',
                                    paddingTop: '12px',
                                }}
                                onClick={() => renderExecuterId(params.row._id)}
                            >
                                {params.row.current_price}
                            </Typography>
                        );
                    }
                },
            },
        ],
        [],
    );

    const requests = () => {
        if (user.app_type.includes('APCM')) {
            return <label>{reqCount}</label>;
        } else {
            return <label>{reqCoundID}</label>;
        }
    };

    const execRequests = () => {
        if (user.app_type.includes('APCM')) {
            return <label>{execCount}</label>;
        } else {
            return <label>{execCountID}</label>;
        }
    };

    const pendingRequests = () => {
        {
            user.app_type.includes('APCM_Authorizer')
                ? navigateTo(`/${ROUTE_PATHS.groupId}`)
                : navigateTo(`/${ROUTE_PATHS.executor}`);
        }
        dispatch(clearDataSource());
    };
    const widgets = () => {
        return (
            <>
                <div
                    className="single__card"
                    onClick={() => navigateTo(`/${ROUTE_PATHS.priceRequest}`)}
                >
                    <div className="card__content">
                        <Typography variant="h4">
                            Total Price Request Raised
                        </Typography>
                        {requests()}
                    </div>

                    <span className="card__icon">
                        <i>
                            <RequestPageIcon fontSize="large" />
                        </i>
                    </span>
                </div>
                <div
                    className="single__card"
                    onClick={() =>
                        navigateTo(`/${ROUTE_PATHS.priceRequestExec}`)
                    }
                >
                    <div className="card__content">
                        <Typography variant="h4">
                            Total Price Request Executed
                        </Typography>
                        {execRequests()}
                    </div>

                    <span className="card__icon">
                        <i>
                            <CheckCircleOutlineOutlinedIcon fontSize="large" />
                        </i>
                    </span>
                </div>
                {!user.app_type.includes('APCM') ? (
                    <div
                        className="single__card"
                        onClick={() => pendingRequests()}
                    >
                        <div className="card__content">
                            <Typography variant="h4">
                                Pending Price Requests
                            </Typography>
                            <label>
                                {user.app_type.includes('APCM_Authorizer')
                                    ? noConfirmed
                                    : noExecuted}
                            </label>
                        </div>

                        <span className="card__icon">
                            <i>
                                <RequestPageIcon fontSize="large" />
                            </i>
                        </span>
                    </div>
                ) : (
                    ''
                )}
                <div
                    className="single__card"
                    onClick={() => handleLiveAssets()}
                >
                    <div className="card__content">
                        <Typography variant="h4">Stations Status</Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                <label style={{ marginRight: '10px' }}>
                                    {
                                        panelData?.assetdata.map(item => item)
                                            .length
                                    }
                                </label>
                                <Typography>Total</Typography>
                            </div>
                            <div>
                                <label
                                    style={{
                                        color: 'greenyellow',
                                        marginRight: '10px',
                                    }}
                                >
                                    {
                                        panelData?.assetdata.filter(
                                            g => g.COMM_STS === 1,
                                        ).length
                                    }
                                </label>
                                <Typography
                                    style={{
                                        color: 'greenyellow',
                                    }}
                                >
                                    On
                                </Typography>
                            </div>
                            <div>
                                <label style={{ color: '#A5200B ' }}>
                                    {
                                        panelData?.assetdata.filter(
                                            g => g.COMM_STS === 0,
                                        ).length
                                    }
                                </label>
                                <Typography
                                    style={{
                                        color: '#A5200B',
                                    }}
                                >
                                    Off
                                </Typography>
                            </div>
                        </div>
                    </div>

                    <span className="card__icon">
                        <i>
                            <RadioButtonCheckedIcon fontSize="large" />
                        </i>
                    </span>
                </div>
            </>
        );
    };
    return (
        <>
            <div className="dashboard">
                <div className="dashboard__wrapper">
                    <div className="dashboard__cards">
                        <>
                            <div
                                className="single__card"
                                onClick={() => {
                                    user.app_type.includes('APCM')
                                        ? navigateTo(`/${ROUTE_PATHS.groups}`)
                                        : navigateTo(
                                              `/${ROUTE_PATHS.groupsByID}`,
                                          );
                                }}
                            >
                                <div className="card__content">
                                    <Typography variant="h4">
                                        Total Groups
                                    </Typography>
                                    <label>
                                        {user.app_type.includes('APCM')
                                            ? groupCount
                                            : filteredGroups?.length}
                                    </label>
                                </div>

                                <span className="card__icon">
                                    <i>
                                        <GroupsIcon fontSize="large" />
                                    </i>
                                </span>
                            </div>
                            {user.app_type.includes('APCM') ? (
                                <div
                                    className="single__card"
                                    onClick={() =>
                                        navigateTo(`/${ROUTE_PATHS.user}`)
                                    }
                                >
                                    <div className="card__content">
                                        <Typography variant="h4">
                                            Total Users
                                        </Typography>
                                        <label>{userCount}</label>
                                    </div>

                                    <span className="card__icon">
                                        <i>
                                            <AccountCircleIcon fontSize="large" />
                                        </i>
                                    </span>
                                </div>
                            ) : (
                                ''
                            )}
                            {widgets()}
                        </>
                    </div>
                </div>
            </div>

            <Paper sx={{ marginRight: '22px', marginLeft: '22px' }}>
                <Grid container>
                    <Grid item xs>
                        <Typography variant="h6" style={{ marginLeft: '18px' }}>
                            Groups
                        </Typography>
                        <Box variant="outlined" p={2}>
                            <Paper
                                style={{
                                    backgroundColor: 'transparent',
                                }}
                            >
                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: 'divider',
                                    }}
                                >
                                    <DataGrid
                                        disableColumnMenu
                                        rows={
                                            user.app_type.includes('APCM')
                                                ? groupInfo
                                                : filteredGroups
                                        }
                                        columns={columns}
                                        getRowId={row => row._id}
                                        style={{
                                            // width: '655px',
                                            height: '490px',
                                        }}
                                        rowsPerPageOptions={[7, 25, 50]}
                                        pageSize={pageSize}
                                        onPageSizeChange={newPage =>
                                            setPageSize(newPage)
                                        }
                                        getRowSpacing={params => ({
                                            top: params.isFirstVisible ? 0 : -2,
                                            bottom: params.isLastVisible
                                                ? 0
                                                : -2,
                                        })}
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Grid>
                    &nbsp;&nbsp;
                    <Grid item xs>
                        <Typography variant="h6" style={{ marginLeft: '18px' }}>
                            Latest Price Request Executed
                        </Typography>
                        <Box
                            sx={{
                                height: '95%',
                                width: '100%',
                                paddingTop: 2,
                            }}
                            p={2}
                        >
                            <Paper>
                                <DataGrid
                                    disableColumnMenu
                                    rows={
                                        user.app_type.includes('APCM')
                                            ? executersData
                                            : latestExecData
                                    }
                                    columns={columns1}
                                    getRowId={row => row._id}
                                    rowsPerPageOptions={[7, 25, 50]}
                                    pageSize={pages}
                                    onPageSizeChange={newPage =>
                                        setPages(newPage)
                                    }
                                    style={{
                                        height: '490px',
                                    }}
                                    getRowSpacing={params => ({
                                        top: params.isFirstVisible ? 0 : -2,
                                        bottom: params.isLastVisible ? 0 : -2,
                                    })}
                                />
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};

export default ApcmDashboard;
